import { render, staticRenderFns } from "./NoorPaymentOptions.vue?vue&type=template&id=29d21f28&scoped=true&"
import script from "./NoorPaymentOptions.vue?vue&type=script&lang=js&"
export * from "./NoorPaymentOptions.vue?vue&type=script&lang=js&"
import style0 from "./NoorPaymentOptions.vue?vue&type=style&index=0&id=29d21f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d21f28",
  null
  
)

export default component.exports